{
  "verified": "2026-09-13",
  "url": "https://www.bls.gov/news.release/ebs2.htm",
  "sha256": "981c5f305989e59eeb6ca791ff3d98603f74922afc72d28c12e90fbade9db10a",
  "rows": [
    {
      "label": "All workers",
      "leave": [
        80,
        80,
        81
      ],
      "retirement": [
        72,
        53,
        73
      ],
      "medical": [
        72,
        45,
        63
      ]
    },
    {
      "label": "Management, professional, and related occupations",
      "leave": [
        93,
        90,
        91
      ],
      "retirement": [
        85,
        73,
        86
      ],
      "medical": [
        87,
        60,
        69
      ]
    },
    {
      "label": "Management, business, and financial occupations",
      "leave": [
        96,
        97,
        96
      ],
      "retirement": [
        90,
        79,
        88
      ],
      "medical": [
        94,
        69,
        74
      ]
    },
    {
      "label": "Professional and related occupations",
      "leave": [
        91,
        87,
        89
      ],
      "retirement": [
        83,
        70,
        84
      ],
      "medical": [
        83,
        55,
        66
      ]
    },
    {
      "label": "Service occupations",
      "leave": [
        65,
        59,
        56
      ],
      "retirement": [
        47,
        25,
        53
      ],
      "medical": [
        48,
        22,
        46
      ]
    },
    {
      "label": "Sales and office occupations",
      "leave": [
        81,
        80,
        86
      ],
      "retirement": [
        77,
        54,
        69
      ],
      "medical": [
        69,
        43,
        62
      ]
    },
    {
      "label": "Office and administrative support occupations",
      "leave": [
        88,
        88,
        90
      ],
      "retirement": [
        78,
        61,
        78
      ],
      "medical": [
        79,
        50,
        63
      ]
    },
    {
      "label": "Full time",
      "leave": [
        88,
        93,
        92
      ],
      "retirement": [
        81,
        62,
        77
      ],
      "medical": [
        87,
        57,
        65
      ]
    },
    {
      "label": "Part time",
      "leave": [
        56,
        40,
        50
      ],
      "retirement": [
        47,
        23,
        49
      ],
      "medical": [
        25,
        10,
        42
      ]
    },
    {
      "label": "Service-providing industries",
      "leave": [
        80,
        78,
        79
      ],
      "retirement": [
        71,
        51,
        71
      ],
      "medical": [
        69,
        42,
        61
      ]
    },
    {
      "label": "1 to 49 workers",
      "leave": [
        73,
        71,
        73
      ],
      "retirement": [
        55,
        38,
        70
      ],
      "medical": [
        54,
        31,
        58
      ]
    },
    {
      "label": "50 to 99 workers",
      "leave": [
        75,
        76,
        74
      ],
      "retirement": [
        71,
        45,
        63
      ],
      "medical": [
        73,
        43,
        58
      ]
    },
    {
      "label": "100 to 499 workers",
      "leave": [
        87,
        87,
        90
      ],
      "retirement": [
        86,
        60,
        70
      ],
      "medical": [
        85,
        55,
        65
      ]
    },
    {
      "label": "500 workers or more",
      "leave": [
        90,
        91,
        93
      ],
      "retirement": [
        90,
        76,
        84
      ],
      "medical": [
        90,
        63,
        70
      ]
    }
  ]
}
